import { ButtonColors, ButtonTypes } from '../../../ui/gzButton/types';

export interface IntegrationsMarketplaceCardData {
  statusType: number;
  name: string;
  description: string;
  linkLabel: string;
  status: string;
  company: any;
  image?: string; // TODO: handle showing custom images
  details?: IntegrationsMarketplaceCardDetails;
  actionButtons?: IntegrationsMarketplaceCardActionButton[];
  readonly?: boolean;
  historyLogsVisible?: boolean;
  hoverEditable?: boolean;
  type?: number;
}

export interface IntegrationsMarketplaceCardDetails {
  integrationName?: string;
  company?: string;
  // for lastSync, started, stopped, the string format is 'DD MMM YYYY, HH:mm'. If not provided, default value is 'N/A'
  lastSync?: string;
  started?: string;
  stopped?: string;
  errorLogs?: unknown; // TODO: handle type
  errorLinkLabel?: string;
}

export interface IntegrationsMarketplaceCardActionButton {
  label: string;
  type: ButtonTypes;
  color: ButtonColors;
  action?: string;
  id?: string;
  disabled?: boolean;
}

export enum IntegrationsMarketplaceCardEvents {
  CARD_CLICK = 'card-click',
  LINK_CLICK = 'link-click',
  HISTORY_LOGS_CLICK = 'history-button-click',
  ACTION_BUTTON_CLICK = 'action-button-click',
}
